import { inject, Injectable } from '@angular/core';
import { catchError, map, Observable, of, tap } from 'rxjs';
import { LoggerService } from '@pf/shared-services';
import { NativeBridgeService } from '../native-bridge.service';
import { NativePrintResult } from '../models/native-print-result';
import { IS_CT_WEB_VIEW } from '../is-ct-web-view.token';

@Injectable({ providedIn: 'root' })
export class NativePrintService {
    private readonly logger = inject(LoggerService);
    private readonly nativeBridge = inject(NativeBridgeService);
    private readonly isWebView = inject(IS_CT_WEB_VIEW);

    /** Whether the Android-native print bridge is available in this runtime. */
    get canUseNativePrint(): boolean {
        return this.isWebView;
    }

    printViaNativePrint(
        ipAddress: string,
        port: number,
        zpl: string
    ): Observable<boolean> {
        return this.nativeBridge
            .invoke<NativePrintResult>('print', callbackId =>
                window.CT_Native_Print?.print(ipAddress, port, zpl, callbackId)
            )
            .pipe(
                tap(result => {
                    if (result.error) {
                        this.logger.error(
                            'Native Print Job Error: ' + result.error
                        );
                    }
                }),
                map(result => result.success),
                catchError(err => {
                    this.logger.error('Native Print failed', err);
                    return of(false);
                })
            );
    }
}
